import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Campaigns: the list, and one campaign's page. */
export const Route = createFileRoute("/_app/growth/campaigns")({
  component: Outlet,
});
